var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('section',[_c('StrapiMarkdownComponent',{attrs:{"item":_vm.item.attributes.entete}}),_vm._l((_vm.item.attributes.contenu),function(bloc,index){return [_c(_vm.getComponent(bloc.__component),{key:index,tag:"component",attrs:{"item":bloc}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }